import { render, staticRenderFns } from "./AdminPasswordReset.vue?vue&type=template&id=6a4308a9&scoped=true"
import script from "./AdminPasswordReset.vue?vue&type=script&lang=js"
export * from "./AdminPasswordReset.vue?vue&type=script&lang=js"
import style0 from "./AdminPasswordReset.vue?vue&type=style&index=0&id=6a4308a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4308a9",
  null
  
)

export default component.exports